import {TokenCredentials} from '../login/tokencredentials';

export class LocationType {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    name : string;
    
    picking : boolean;
	transport : boolean;
	compact : boolean;
	inbound : boolean;
	outbound : boolean;
	count : boolean;

    created : Date;
    updated : Date;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location-type.ts